import { ActivitiesType } from '@tabeeb/contracts/main-api/swagger-main-api'

export const ActivitiesTypeDisplayName = {
  [ActivitiesType.All]: 'All',
  [ActivitiesType.AIFlag]: 'AI Flag',
  [ActivitiesType.Flag]: 'Flag',
  [ActivitiesType.Drawing]: 'Drawing',
  [ActivitiesType.Image]: 'Image',
  [ActivitiesType.Shape]: 'Shape',
  [ActivitiesType.Text]: 'Text',
  [ActivitiesType.Audio]: 'Voice Over',
}

export enum DisplayPage {
  All = 'all',
  Current = 'current',
}
